<tt-page class="col-xs-12 col-md-6 sp-0" *ngIf="!!edit">
    <tt-card>
        <tt-input ttLabel="poh_keyno_top" [ttModel]="edit.poh_keyno_top" ttReadonly></tt-input>
        <tt-input ttLabel="po_keyno" [ttModel]="edit.po_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="prod_id" [ttModel]="edit.prod_id" ttReadonly></tt-input>
        <tt-input ttLabel="prod_name_long" [ttModel]="edit.prod_name_long" ttReadonly></tt-input>
        <tt-input-number ttLabel="quantity" [ttModel]="edit.quantity" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-select ttLabel="postatus" [(ttModel)]="edit.postatus_no" [ttData]="selectListPoStatuses" ttDataId="postatus_no" ttDataName="postatus_name"></tt-select>
        <tt-date ttLabel="lastdt_finish" [ttModel]="edit.lastdt_finish" ttReadonly></tt-date>
    </tt-card>

    <tt-list [ttData]="itemsListSubPos" [ttBadge]="'badgeinfo'"></tt-list>

    <tt-card>
        <tt-button [ttText]="'pohtop_print'" (ttClick)="goToFunc('selectreport')" ttTextAlign="center" ttIcon="fa fa-print"></tt-button>
    </tt-card>
</tt-page>
